export enum ApplicationStepStatus {
  Complete = "Complete",
  Active = "Active",
  InProgress = "InProgress",
  Disabled = "Disabled",
  Enabled = "Enabled",
}
